const newsConstants = {
  GET_NEWS_LIST_REQUEST:           'GET_NEWS_LIST_REQUEST',
  GET_NEWS_LIST_SUCCESS:           'GET_NEWS_LIST_SUCCESS',
  GET_NEWS_LIST_FAILURE:           'GET_NEWS_LIST_FAILURE',
  GET_NEWS_DETAIL_REQUEST:         'GET_NEWS_DETAIL_REQUEST',
  GET_NEWS_DETAIL_SUCCESS:         'GET_NEWS_DETAIL_SUCCESS',
  GET_NEWS_DETAIL_FAILURE:         'GET_NEWS_DETAIL_FAILURE',
  NEWS_SHOW_MORE_REQUEST:          'NEWS_SHOW_MORE_REQUEST',
  NEWS_SHOW_MORE_SUCCESS:          'NEWS_SHOW_MORE_SUCCESS',
  NEWS_SHOW_MORE_FAILURE:          'NEWS_SHOW_MORE_FAILURE',
  NEWS_DETAIL_RESET_INITIAL_STATE: 'NEWS_DETAIL_RESET_INITIAL_STATE',
};

export default newsConstants;